module.exports = __webpack_public_path__ + "img/inncash_white.2c5b51f3.png";